import { Panel } from "@mcleod/components";
import { VerticalAlignment } from "@mcleod/core";

// TODO Stub. Footer will inevitably have use cases, but I'd prefer to know some prior to writing this out.
//  I envision bottom navigation options being defined within index.ts of the module
//  (ex. mcleod-ui-lme-mobile) and this Panel react to options provided.
export class AppPageFooter extends Panel {
    private static _instance: AppPageFooter;

    private constructor() {
        super({
            id: "pageFooter",
            padding: 0,
            fillRow: true,
            verticalAlign: VerticalAlignment.CENTER
        });
        AppPageFooter._instance = this;
    }

    public static get instance(): AppPageFooter {
        if (this._instance == null) {
            this._instance = new AppPageFooter();
        }
        return this._instance;
    }
}
